import React, { useMemo } from "react";
import './cookbookRecipesList.scss';
import { RecipePanel } from "./RecipePanel";
import { minutesToPrepTime } from "../utils";
import { TCookbook, TRecipeAbridged } from "../../types/cookbook";
import { useNavigate } from "react-router-dom";
import { TRecipe, TRecipeSortOrder, sortedRecipes } from "../../types/recipe";

type TCookbookRecipesListProps = {
    cookbook: TCookbook;
    sortOrder: TRecipeSortOrder;
}

type TCookbookRecipeRowProps = {
    recipe: TRecipeAbridged;
    sortOrder?: TRecipeSortOrder;
    onPlanner?: boolean;
}

export const CookbookRecipeRow = ({recipe, sortOrder, onPlanner}: TCookbookRecipeRowProps) => {
    const navigate = useNavigate();
    const link = onPlanner ? `/planner/recipe/${recipe.id}` : sortOrder ? `/recipe/${recipe.id}?cookbook=${sortOrder}` : `/recipe/${recipe.id}`
    return <div className="recipe-row-container" onClick={() => navigate(link)}>
        <RecipePanel hidePlanner={true} recipe={recipe} hideText={true} className={"on-cookbook-page"}/>
        <div className="recipe-row-details">
            <div>
                <div className="recipe-title">
                    {recipe.title}
                </div>
                <div className="recipe-data">
                    {recipe.total_time ?
                        `${minutesToPrepTime(recipe.total_time)} | ${recipe.ingredients.length} ings` :
                        `${recipe.ingredients.length} ings`}
                </div>
            </div>
            <div className="uploader">
                Added by: {recipe.uploader.first_name || recipe.uploader.username}
            </div>
        </div>
    </div>
}

export const CookbookRecipesList = ({cookbook, sortOrder}: TCookbookRecipesListProps) => {
    const recipes: TRecipeAbridged[] = useMemo(() => {
        return sortedRecipes(cookbook.recipes, sortOrder)
    }, [cookbook.recipes, sortOrder]);

    return <div className="recipes-list-container">
        {recipes.length === 0 && <div className="empty-list">
            This cookbook is currently empty.
            </div>}
        {recipes.map(r => <CookbookRecipeRow sortOrder={sortOrder} key={`recipe-${r.id}-${r.title}`} recipe={r}/>)}
    </div>
}